<script setup lang="ts">
import { ButtonComponent } from '@metapic-apps/shared'
import { ref } from 'vue'

import NotificationIcon from '@/assets/icons/notifications.svg?component'
import NotificationContent from '@/components/NotificationCenter/NotificationContent.vue'
import { useNovuWebsocketService } from '@/lib/hooks/novu.hooks'
import { useNotificationStore } from '@/stores/notifications.stores'

const notificationPopup = ref()
const notificationStore = useNotificationStore()

const activeTab = ref<'all' | 'unread'>('all')

const handleClose = () => {
  if (!notificationPopup.value) {
    return
  }
  notificationPopup.value.handleClose()
}

useNovuWebsocketService()
</script>
<template>
  <div class="notification-center__container">
    <el-dropdown ref="notificationPopup" trigger="click" :persistent="false">
      <ButtonComponent
        is-icon
        variant="text"
        :class="['notification-center__button', { 'unread-notification': !!notificationStore.unread.total }]"
      >
        <NotificationIcon />
      </ButtonComponent>
      <template #dropdown>
        <NotificationContent v-model="activeTab" @close="handleClose" />
      </template>
    </el-dropdown>
  </div>
</template>
<style lang="scss" scoped>
.notification-center__container {
  position: relative;
}

.notification-center__button {
  position: relative;

  &.unread-notification {
    &:after {
      content: '';
      position: absolute;
      top: 4px;
      right: 4px;
      background: red;
      border-radius: 50%;
      width: 8px;
      height: 8px;
    }
  }
}
</style>
